
import { IGetIndicatorStatusHistoryByPointsParameters } from "./IGetIndicatorStatusHistoryByPointsParameters";


export class GetIndicatorStatusHistoryByPointsParameters implements IGetIndicatorStatusHistoryByPointsParameters
{
    componentId: number = 0;
    indicatorId: number = 0;
    fromDate: Date = new Date();
    toDate: Date = new Date();
    maxPoints: number = 0;
}
